import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby'

import Button from '../Button'

import ContentWrapper from '../ContentWrapper'

import * as styles from './style.module.sass'

const Benefit = ({ icon, text }) => (
  <div className={`${styles.benefit}`}>
    <img src={icon.publicURL} alt={`icon-${text}`} />
    <ReactMarkdown>{text}</ReactMarkdown>
  </div>
)

const Benefits = ({ benefitsTitle, benefitsImage, benefits, descriptionLinkText, buttonURL, buttonText }) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <img src={benefitsImage.publicURL} alt="background" />
    </div>

    <ContentWrapper>
      <h2 className={styles.title}>
        <ReactMarkdown>{benefitsTitle}</ReactMarkdown>
      </h2>

      <div className={`${styles.benefitsContainer} columns is-gapless`}>
        {benefits.map((benefit, i) => (
          <div
            className={`${styles.benefitContainer} column is-one-quarter-desktop is-one-third-tablet is-half-mobile`}
            key={i}
          >
            <Benefit icon={benefit.icon} text={benefit.text} />
          </div>
        ))}
      </div>

      {!!buttonURL && (
        <div className={styles.buttonContainer}>
          {!!descriptionLinkText ? (
            <>
              <p className={styles.descriptionLinkText}>{descriptionLinkText}</p>
              <Link className={styles.linkContainer} to={buttonURL}>
                <p>{buttonText}</p>
              </Link>
            </>
          ) : (
            <a className={styles.linkButton} href={buttonURL} target='_blank' rel='noreferrer'>
              <Button width={'100%'}>{buttonText}</Button>
            </a>
          )}
        </div>
      )}
    </ContentWrapper>
  </div>
)

export default Benefits
